/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  StorageConfigResponse,
  UpdateStorageConfigBody,
  V1StorageBucketResponse
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary Lists all buckets
 */
export type v1ListAllBucketsResponse200 = {
  data: V1StorageBucketResponse[]
  status: 200
}

export type v1ListAllBucketsResponse401 = {
  data: void
  status: 401
}

export type v1ListAllBucketsResponse403 = {
  data: void
  status: 403
}

export type v1ListAllBucketsResponse429 = {
  data: void
  status: 429
}

export type v1ListAllBucketsResponse500 = {
  data: void
  status: 500
}

export type v1ListAllBucketsResponseSuccess = (v1ListAllBucketsResponse200) & {
  headers: Headers;
};
export type v1ListAllBucketsResponseError = (v1ListAllBucketsResponse401 | v1ListAllBucketsResponse403 | v1ListAllBucketsResponse429 | v1ListAllBucketsResponse500) & {
  headers: Headers;
};

export type v1ListAllBucketsResponse = (v1ListAllBucketsResponseSuccess | v1ListAllBucketsResponseError)

export const getV1ListAllBucketsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/storage/buckets`
}

export const v1ListAllBuckets = async (ref: string, options?: RequestInit): Promise<v1ListAllBucketsResponse> => {
  
  return customFetch<v1ListAllBucketsResponse>(getV1ListAllBucketsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets project's storage config
 */
export type v1GetStorageConfigResponse200 = {
  data: StorageConfigResponse
  status: 200
}

export type v1GetStorageConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetStorageConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetStorageConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetStorageConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetStorageConfigResponseSuccess = (v1GetStorageConfigResponse200) & {
  headers: Headers;
};
export type v1GetStorageConfigResponseError = (v1GetStorageConfigResponse401 | v1GetStorageConfigResponse403 | v1GetStorageConfigResponse429 | v1GetStorageConfigResponse500) & {
  headers: Headers;
};

export type v1GetStorageConfigResponse = (v1GetStorageConfigResponseSuccess | v1GetStorageConfigResponseError)

export const getV1GetStorageConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/storage`
}

export const v1GetStorageConfig = async (ref: string, options?: RequestInit): Promise<v1GetStorageConfigResponse> => {
  
  return customFetch<v1GetStorageConfigResponse>(getV1GetStorageConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates project's storage config
 */
export type v1UpdateStorageConfigResponse200 = {
  data: void
  status: 200
}

export type v1UpdateStorageConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdateStorageConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdateStorageConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdateStorageConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdateStorageConfigResponseSuccess = (v1UpdateStorageConfigResponse200) & {
  headers: Headers;
};
export type v1UpdateStorageConfigResponseError = (v1UpdateStorageConfigResponse401 | v1UpdateStorageConfigResponse403 | v1UpdateStorageConfigResponse429 | v1UpdateStorageConfigResponse500) & {
  headers: Headers;
};

export type v1UpdateStorageConfigResponse = (v1UpdateStorageConfigResponseSuccess | v1UpdateStorageConfigResponseError)

export const getV1UpdateStorageConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/storage`
}

export const v1UpdateStorageConfig = async (ref: string,
    updateStorageConfigBody: UpdateStorageConfigBody, options?: RequestInit): Promise<v1UpdateStorageConfigResponse> => {
  
  return customFetch<v1UpdateStorageConfigResponse>(getV1UpdateStorageConfigUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateStorageConfigBody,)
  }
);}
  

